<template>
    <v-dialog v-model="dialogUpload" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="title">{{title}}</span>
        </v-card-title>
        <v-card-text>
            <div class="flex w-full h-screen items-center justify-center text-center" id="upload-form">
                <div class="p-12 bg-gray-100 border border-gray-300" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                    <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle" style="display:none" class="w-px h-px opacity-0 overflow-hidden absolute" @input="onChange" ref="file" :accept="file_types || '.xls, .xlsx'" />
                
                    <label for="assetsFieldHandle" class="block cursor-pointer">
                      <div class="upload-label">
                          <p v-if="temp_file"><a :href="temp_file" target="_blank">Tệp mẫu</a></p>
                          Kéo tệp tin, <span class="underline">bấm vào đây</span> để chọn tệp,<br/>
                          hoặc <strong>Ctrl+V</strong> để dán ảnh từ clipboard.
                      </div>
                    </label>
                    <ul class="mt-4" v-if="this.filelist.length" v-cloak>
                    <li class="text-sm p-1" v-for="file in filelist" :key="file.name">
                       <span class="ellipsis">{{ file.name }}</span><button class="ml-2 remove" type="button" @click="remove(filelist.indexOf(file))" title="Xóa file">xóa file</button>
                    </li>
                    </ul>
                </div>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="closePopup">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="importFile">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
export default {
  name: "upload-file-popup",
  data() {
    return {
      filelist: [] // Store our uploaded files
    };
  },
  props: ["dialogUpload", "title", "temp_file", "file_types"],
  mounted() {
    // Add paste event listener when component is mounted
    document.addEventListener('paste', this.handlePaste);
  },
  beforeDestroy() {
    // Remove paste event listener when component is destroyed
    document.removeEventListener('paste', this.handlePaste);
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    importFile() {
      this.$emit("importFile", this.filelist);
    },
    onChange() {
      this.filelist = [...this.$refs.file.files];
      this.$refs.file.value = null;
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('bg-green-300')) {
        event.currentTarget.classList.remove('bg-gray-100');
        event.currentTarget.classList.add('bg-green-300');
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    },
    handlePaste(event) {
      // Only handle paste when dialog is open
      if (!this.dialogUpload) return;
      
      const clipboardItems = event.clipboardData && event.clipboardData.items;
      if (!clipboardItems) return;
      
      for (let i = 0; i < clipboardItems.length; i++) {
        const item = clipboardItems[i];
        
        // Check if the item is an image
        if (item.type.indexOf('image') !== -1) {
          const blob = item.getAsFile();
          if (blob) {
            // Create a file name with timestamp
            const timestamp = new Date().getTime();
            const extension = item.type.split('/')[1] || 'png';
            const fileName = `pasted-image-${timestamp}.${extension}`;
            
            // Create a new File object with proper name
            const file = new File([blob], fileName, { type: item.type });
            
            // Add to file list
            this.filelist.push(file);
            
            // Prevent default paste behavior
            event.preventDefault();
            break;
          }
        }
      }
    }
  }
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}
.underline {
  text-decoration: underline;
  cursor: pointer;
}
.border {
    border: 1px solid #a7a7a7
}
ul {
  list-style: none
}
.remove{
    color: rgb(245, 8, 8)
}
#upload-form label {
  margin-top: 20px;
  height: 200px;
}
.bg-gray-100 {
  background-color: #f7f7f7;
  height: 200px;
}
.bg-green-300 {
  background-color: #90ee90;
  height: 200px;
}
.upload-label {
  margin-top: 20px;
}
#upload-form li {
  text-align: left;
}
.ellipsis {
  display: inline-block; /* Đảm bảo áp dụng đúng cho inline elements */
  max-width: 200px; /* Đặt chiều rộng tối đa */
  white-space: nowrap; /* Không cho phép xuống dòng */
  overflow: hidden; /* Ẩn nội dung tràn ra ngoài */
  text-overflow: ellipsis; /* Hiển thị "..." */
}
</style>